import { render } from "./DQRViewer.vue?vue&type=template&id=484f2e36"
import script from "./DQRViewer.vue?vue&type=script&lang=js"
export * from "./DQRViewer.vue?vue&type=script&lang=js"

import "./DQRViewer.vue?vue&type=style&index=0&id=484f2e36&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__